import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faStore, faMapMarkerAlt, faPhone, faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import baseURL from '../../url';
import { usePlan } from '../../PlanContext';

export default function SucursalesData() {
    const { features } = usePlan();
    const limites = features?.limites || {};
    const [sucursales, setSucursales] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [editando, setEditando] = useState(null);
    const [form, setForm] = useState({ nombre: '', direccion: '', telefono: '', activo: 1 });

    useEffect(() => { cargar(); }, []);

    const cargar = () => {
        fetch(`${baseURL}/sucursalesGet.php`)
            .then(r => r.json())
            .then(d => setSucursales(d.sucursales || []))
            .catch(err => console.error(err));
    };

    const abrirNuevo = () => {
        setEditando(null);
        setForm({ nombre: '', direccion: '', telefono: '', activo: 1 });
        setModalOpen(true);
    };

    const abrirEditar = (s) => {
        setEditando(s.idSucursal);
        setForm({ nombre: s.nombre, direccion: s.direccion || '', telefono: s.telefono || '', activo: Number(s.activo) });
        setModalOpen(true);
    };

    const guardar = async (e) => {
        e.preventDefault();
        if (!form.nombre.trim()) return toast.error('Nombre requerido');
        try {
            if (editando) {
                const res = await fetch(`${baseURL}/sucursalPut.php?idSucursal=${editando}`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(form),
                });
                const data = await res.json();
                if (data.error) return toast.error(data.error);
                toast.success(data.mensaje);
            } else {
                const fd = new FormData();
                Object.entries(form).forEach(([k, v]) => fd.append(k, v));
                const res = await fetch(`${baseURL}/sucursalesPost.php`, { method: 'POST', body: fd });
                const data = await res.json();
                if (data.error) return toast.error(data.error);
                toast.success(data.mensaje);
            }
            setModalOpen(false);
            cargar();
        } catch (err) {
            toast.error('Error: ' + err.message);
        }
    };

    const eliminar = (id) => {
        Swal.fire({
            title: '¿Eliminar sucursal?',
            text: 'Esta acción no se puede deshacer',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#dc3545',
        }).then(r => {
            if (r.isConfirmed) {
                fetch(`${baseURL}/sucursalDelete.php?idSucursal=${id}`, { method: 'DELETE' })
                    .then(r => r.json())
                    .then(d => {
                        if (d.error) toast.error(d.error);
                        else { toast.success(d.mensaje); cargar(); }
                    });
            }
        });
    };

    return (
        <div>
            <ToastContainer />
            {sucursales.length >= (limites.sucursales ?? 1) && (
                <div style={{
                    background: '#fff8e1',
                    border: '1px solid #ffc107',
                    color: '#7a5b00',
                    padding: '10px 14px',
                    borderRadius: '8px',
                    marginBottom: '16px',
                    fontSize: '13px',
                }}>
                    ⚠️ Alcanzaste el límite de {limites.sucursales ?? 1} sucursales. Adquirí un paquete para agregar más.
                </div>
            )}
            <div className='deFlexContent'>
                <div className='deFlex2'>
                    <button className='btnSave' onClick={abrirNuevo}>
                        <span> + </span> Nueva sucursal
                    </button>
                </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '14px', marginTop: '20px' }}>
                {sucursales.length === 0 && (
                    <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '40px', color: '#6c757d' }}>
                        No tenés sucursales aún. Creá la primera.
                    </div>
                )}
                {sucursales.map(s => (
                    <div key={s.idSucursal} style={{
                        background: '#fff', borderRadius: '10px', padding: '16px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                        borderLeft: `4px solid ${Number(s.activo) ? '#28a745' : '#dc3545'}`,
                    }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
                            <h3 style={{ margin: 0, fontSize: '17px', color: '#212529', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <FontAwesomeIcon icon={faStore} style={{ color: '#6c757d' }} />
                                {s.nombre}
                            </h3>
                            <span style={{
                                fontSize: '11px', fontWeight: 700,
                                color: Number(s.activo) ? '#28a745' : '#dc3545',
                                display: 'flex', alignItems: 'center', gap: '4px',
                            }}>
                                <FontAwesomeIcon icon={Number(s.activo) ? faCheckCircle : faTimesCircle} />
                                {Number(s.activo) ? 'ACTIVA' : 'INACTIVA'}
                            </span>
                        </div>
                        {s.direccion && (
                            <div style={{ fontSize: '13px', color: '#495057', margin: '6px 0', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <FontAwesomeIcon icon={faMapMarkerAlt} /> {s.direccion}
                            </div>
                        )}
                        {s.telefono && (
                            <div style={{ fontSize: '13px', color: '#495057', margin: '6px 0', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <FontAwesomeIcon icon={faPhone} /> {s.telefono}
                            </div>
                        )}
                        <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                            <button className='editar' onClick={() => abrirEditar(s)} style={{ flex: 1 }}>
                                <FontAwesomeIcon icon={faEdit} /> Editar
                            </button>
                            <button className='eliminar' onClick={() => eliminar(s.idSucursal)} style={{ flex: 1 }}>
                                <FontAwesomeIcon icon={faTrash} /> Eliminar
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {modalOpen && (
                <div className='modal'>
                    <div className='modal-content'>
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>{editando ? 'Editar' : 'Nueva'} sucursal</button>
                            <span className='close' onClick={() => setModalOpen(false)}>&times;</span>
                        </div>
                        <form onSubmit={guardar}>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Nombre</legend>
                                    <input type='text' value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })} required placeholder='Sucursal Centro' />
                                </fieldset>
                                <fieldset>
                                    <legend>Dirección</legend>
                                    <input type='text' value={form.direccion} onChange={e => setForm({ ...form, direccion: e.target.value })} placeholder='Av. Principal 123' />
                                </fieldset>
                                <fieldset>
                                    <legend>Teléfono</legend>
                                    <input type='text' value={form.telefono} onChange={e => setForm({ ...form, telefono: e.target.value })} placeholder='+54 9 11 1234-5678' />
                                </fieldset>
                                <fieldset>
                                    <legend>Estado</legend>
                                    <select value={form.activo} onChange={e => setForm({ ...form, activo: Number(e.target.value) })}>
                                        <option value={1}>Activa</option>
                                        <option value={0}>Inactiva</option>
                                    </select>
                                </fieldset>
                            </div>
                            <button type='submit' className='btnPost'>
                                {editando ? 'Guardar cambios' : 'Crear sucursal'}
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
